var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSqOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17.0 17.0",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "i0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M375,0 L375,812 L0,812 L0,0 L375,0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-343.0 -300.0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.0 20.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.0 204.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.0 28.0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(314.0 49.0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L13,0 C14.1045695,-2.02906125e-16 15,0.8954305 15,2 L15,13 C15,14.1045695 14.1045695,15 13,15 L2,15 C0.8954305,15 1.3527075e-16,14.1045695 0,13 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    stroke: "#CCCCCC",
    strokeWidth: 1,
    fill: "none",
    strokeMiterlimit: 10
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSqOutline);
export default __webpack_public_path__ + "static/media/icSqOutline.09578b422e4996249fcff82a4c5d6c7d.svg";
export { ForwardRef as ReactComponent };